/**
 * @file  src\components\Inventory\CreateInventory\NiceToHave\NiceToHaveHelper.js
 * @brief  This file is responsible for nice to have selection in inventory creation
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import PropertyDisplay from "../../../MemberWantAd/PropertyDisplay";
import { useContext } from "react";
import { niceToHaveContext } from "../InventoryNiceToHaves";

const NiceToHaveHelper = (props) => {
  const niceToHave = useContext(niceToHaveContext);
  const { handleItemClick, selectedItems } = niceToHave;
  const { list } = props;
  const itemList =
    list &&
    list.map((pl) => {
      const name = _.get(pl, "Text");
      const id = _.get(pl, "Id");
      const imgPath = _.get(pl, "Img");
      const webPImg = _.get(pl, "Webp_Img");
      const Icon = _.get(pl, "Icon");
      let isSelected = false;

      const filteredArray = selectedItems.filter(function (co) {
        return co.id == id;
      });

      const order = _.get(filteredArray[0], "order", null);
      if (order) {
        isSelected = true;
      }
      return (
        <div
          key={id}
          className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3"
          id={id}
          onClick={handleItemClick}
          onKeyDown={handleItemClick}
          role="button"
        >
          <PropertyDisplay
            name={name}
            id={id}
            isSelected={isSelected}
            imgPath={imgPath}
            webPImg={webPImg}
            order={order}
            icon={Icon}
          />
        </div>
      );
    });
  return itemList;
};

export default NiceToHaveHelper;
